import { deleteCookie } from '../utils/cookie'

export default {
  store (state, payload) {
    Object.assign(state, payload)
  },
  // 更新页面跳转路由记录
  updateDepthHistory (state, payload) {
    const position = state.depthHistory.indexOf(payload)
    if (position > -1) {
      state.depthHistory.splice(position, 1)
    } else {
      state.depthHistory.push(payload)
    }
  },
  // 更新绑定船票信息
  updateBindTicket (state, payload) {
    state.bindTicket = payload
    deleteCookie('shorexId')
  },
  // 退出登录
  logout (state) {
    state.token = ''
    state.bindTicket = ''
    state.goodsCartNum = 0
    state.smCartNum = 0
    deleteCookie('shorexId')
    deleteCookie('token')
  },
  // 解绑船票
  bindout (state) {
    state.bindTicket = ''
  },
  storeBookingPageData (state, payload) {
    state.bookingPage = payload
  },
  SET_IS_MASK_VALUE: (state, isMaskValue) => {
    state.isMaskValue = isMaskValue
  },
  setBookingContactInfo(state,payload) {
    state.bookingContactInfo=payload
  }
}
